import apiClient from '../../../../../services/apiClient';


export const usersAPI = {
  // Получить всех пользователей
  getUsers: async () => {
    return await apiClient.get('users', false);
  },


  getKindergartens: async () => {
    return await apiClient.get('kindergartens/main_info', false);
  },

  // Добавить пользователя
  addUser: async (userData) => {
    return await apiClient.post('users', userData)
  },

  // Обновить пользователя
  updateUser: async (userId, userData) => {
    return await apiClient.put(`users/${userId}`, userData);
  }
};